<template>
  <div id="marketing-layout" class="d-flex flex-column min-vh-100">
    <!-- Marketing Header -->
    <MarketingHeader />

    <!-- Main Content -->
    <main class="flex-grow-1">
      <router-view />
    </main>

    <!-- Marketing Footer -->
    <MarketingFooter />
  </div>
</template>

<script>
import MarketingHeader from '@/components/marketing/MarketingHeader.vue'
import MarketingFooter from '@/components/marketing/MarketingFooter.vue'
// Marketing CSS is now imported globally in main.js for proper PostCSS processing

export default {
  name: 'MarketingLayout',
  components: {
    MarketingHeader,
    MarketingFooter
  }
}
</script>

<style>
/* Base styles scoped ONLY to marketing layout to prevent CoreUI conflicts */
#marketing-layout {
  /* Universal box-sizing */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /* Remove default margins on common elements */
  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  /* Reset lists */
  ul, ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  /* Remove default button styles */
  button {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
  }

  /* Image and media defaults */
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    max-width: 100%;
  }

  /* Links inherit color by default */
  a {
    color: inherit;
    text-decoration: inherit;
  }
}
</style>
